/*
fitTiled does not use the fabric generated JSON that is exported when the user saves.
This is because fabric does a arse job at loading patters. SO, the easier thing to do
is to re-draw the pattern using the source image, and scaling each property by origWidth/newWidth

every fit function must have ability to export as png (aka just the fit watermark) or also composite with image
the straight up fit watermark (aka export png) is for applying from upload + pica resize
the composite fit watermark is used when selecting a watermark from sidebar templates
*/

// must use callback if you are doing simpleComposite!
// compositeBackgroundImage and callback are not required by this function
function fitTiled(tiledProperties, origWidth, origHeight, newWidth, newHeight, outputType, outputQuality = '96', compositeBackgroundImage, callback) {
  let scaleValue = newWidth/origWidth
  // NEED TO CHECK HERE >>> MULTIPLE CANVAS' ARE EXPENSIVE AND UNNECESSARY >> SHOULD CONSIDER RE-USING !!!!
  
  // instantiate Fabric canvas
  var newCanvas = document.createElement('canvas');
  
  // explicitly set dimensions to make sure there's no funny business when loading Fabric JSON obj
  newCanvas.width = newWidth
  newCanvas.height = newHeight

  let fitCanvas = new fabric.StaticCanvas(newCanvas, {width: newWidth, height: newHeight});

  fabric.Image.fromURL(tiledProperties.markForTile, function(img) {
                    
    img.scaleToWidth(tiledProperties.patternScaleToWidth * scaleValue);
    var patternSourceCanvas = new fabric.StaticCanvas();
    patternSourceCanvas.add(img);
    patternSourceCanvas.renderAll();
    var patternFabric = new fabric.Pattern({
        source: function() {
            patternSourceCanvas.setDimensions({
                width: img.getScaledWidth() + tiledProperties.patternPadding,
                height: img.getScaledHeight() + tiledProperties.patternPadding
            });
            patternSourceCanvas.renderAll();
            return patternSourceCanvas.getElement();
        },
        repeat: 'repeat'
    });

    var imgWidth = img.width * img.scaleX 
    var imgHeight = img.height * img.scaleY
    img.set({originX: 'center',originY: 'center', left: imgWidth/2, top: imgHeight/2})
    // already set before it's added img.scaleToWidth(parseInt(tiledProperties.patternScaleToWidth, 10))
    img.set('angle', tiledProperties.patternAngle); 
    img.set("opacity", tiledProperties.patternOpacity / 100);                 
    patternFabric.offsetX = parseInt(tiledProperties.patternOffsetX, 10);
    patternFabric.offsetY = parseInt(tiledProperties.patternOffsetY, 10);

    var rect = new fabric.Rect({
        width: fitCanvas.width,
        height: fitCanvas.height,
        fill: patternFabric,
        objectCaching: false,
        selectable: false
    });

    fitCanvas.add(rect);
    rect.center().setCoords();

    var watermark = fitCanvas.toDataURL('image/png', 1)
    var cbk  = callback;
  
    if (compositeBackgroundImage) {
      //
      // Creating new canvas for composite because fitCanvas.lowerCanvasEl has whacky sizes
      // 
      
      // instantiate Fabric canvas
      var compositeCanvas = document.createElement('canvas');
      var ctx = compositeCanvas.getContext('2d');
      // explicitly set dimensions to make sure there's no funny business when loading Fabric JSON obj
      compositeCanvas.width=newWidth
      compositeCanvas.height=newHeight  
      
      // Load sources
      let sources = [];
      sources = [compositeBackgroundImage, watermark]
      const images = sources.map(source => new Promise((resolve, reject) => {
        // Resolve source and img when loaded
        let img = new Image();
        img.onerror = () => reject(new Error('Couldn\'t load image'));
        img.onload = () => resolve(img);
        img.src = source;
      }));
      
      Promise.all(images)
      .then(images => {
        images.forEach(image => {
          return ctx.drawImage(image, 0, 0);
        });  

        var watermarkComposite
        compositeCanvas.toBlob(function(blob) {
          watermarkComposite = URL.createObjectURL(blob);          
          return cbk({watermark, watermarkComposite}) 
        }, 'image/jpeg', outputQuality)         
      })

      /* USING fitCanvas.toDataURL (which uses fabricjs toDataURL class)
      fabric.Image.fromURL(compositeBackgroundImage, function(oImg) {
        oImg.set({ left: 0, top: 0, width: newWidth, height: newHeight}); 
        fitCanvas.add(oImg);
        fitCanvas.sendToBack(oImg);
        fitCanvas.renderAll();
        // console.log(fitCanvas.toDataURL()) // << !! THIS WORKS ... because Fabric knows when Image is ready... I need to piggy back
        var watermarkComposite = fitCanvas.lowerCanvasEl.toDataURL('image/' + outputType, outputQuality)
        return cbk({watermark, watermarkComposite})
      }, { crossOrigin: 'anonymous' });
      */
    } else if (outputType == 'json') {
      var data = fitCanvas.toJSON();  
      return cbk(data)                    
    } else {             
      var data = fitCanvas.toDataURL('image/png',1); //png by default     
      return cbk(data)               
    }                      

});
  
}

export { fitTiled };